<template>
  <div>
    
  </div>
</template>
<script>
import helpers from "@/helpers";
export default {
  data() {
    return {
      chave: null,
    };
  },
  mounted() {
    this.createRecaptcha();
  },
  methods: {
    createRecaptcha() {
      helpers.getEnv().then((response) => {
        this.chave = response.VUE_APP_RECAPTCHA_KEY;
        //Carregando o script do enterprise
        let recaptchaScript = document.createElement("script");
        recaptchaScript.src = "https://www.google.com/recaptcha/enterprise.js?render="+this.chave;
        document.head.appendChild(recaptchaScript);
      });
    },
    // Ação de login do Recaptcha
    readyRecaptcha() {
      return new Promise((resolve, reject) => {
        window.grecaptcha.enterprise.ready(async() => {
          let token = await window.grecaptcha.enterprise.execute(this.chave,{
            action:'login'
          })
          if (token) {
            this.$emit("token", token); //Enviando token através de emissão de Evento
            resolve(token); //Enviando token através de emissão de Promise
          } else {
            reject("Marque a opção 'Não sou um um robô' no reCAPTCHA");
          }
        })
      });
    },
    reloadRecaptcha(){
      window.grecaptcha.enterprise.reset();
    }
  },
};
</script>